import { Button, Typography } from '@navi/web-ui/lib/primitives';
import ErrorIconOutline from '@cp/src/assets/icons/ErrorIconOutline';

interface DrawerFooterProps {
  onClose: () => void;
  toggleOutsideClick: () => void;
  isDirtyField: boolean;
  isOutsideClick: boolean;
  handleSubmitClick: () => void;
  isSubmitButtonDisabled: boolean;
  handleExitYesClick: () => void;
  handleExitNoClick: () => void;
  isEditPage: boolean;
  buttonTitle: string;
  primaryButtonTitle?: string;
}

export const DrawerFooter = (props: DrawerFooterProps) => {
  const {
    isOutsideClick,
    toggleOutsideClick,
    onClose,
    isDirtyField,
    handleExitYesClick,
    handleExitNoClick,
    handleSubmitClick,
    isSubmitButtonDisabled,
    isEditPage = false,
    buttonTitle,
    primaryButtonTitle = 'Save changes'
  } = props;

  if (isOutsideClick && isDirtyField)
    return (
      <div className={'flex'}>
        <div className="w-[20px] pt-[2px]">
          <ErrorIconOutline />
        </div>
        <div className="items-center">
          <div>
            <Typography variant="h5" color="var(--navi-color-red-base)">
              Your changes will not be saved. Are you sure you want to exit?
            </Typography>
          </div>
          <div className="mt-2">
            <Button variant="secondary" size="small" className="mr-4" onClick={handleExitYesClick}>
              Yes
            </Button>
            <Button variant="primary" type="submit" size="small" onClick={handleExitNoClick}>
              No
            </Button>
          </div>
        </div>
      </div>
    );

  if (isEditPage)
    return (
      <div className={'gap-2'}>
        <Button
          variant="secondary"
          onClick={isDirtyField ? toggleOutsideClick : onClose}
          size="medium"
          className="px-[60px]"
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          type="submit"
          size="medium"
          onClick={handleSubmitClick}
          className="px-[40px] ml-5"
          disabled={isSubmitButtonDisabled || !isDirtyField}
        >
          {primaryButtonTitle}
        </Button>
      </div>
    );
  return (
    <Button
      variant="primary"
      type="submit"
      fullWidth
      onClick={handleSubmitClick}
      disabled={isSubmitButtonDisabled}
    >
      <Typography variant="h4" color="var(--tooltip-text-color)">
        {buttonTitle}
      </Typography>
    </Button>
  );
};

export default DrawerFooter;
